import { styled } from "styled-components";

import { DigitalMemberTag } from "common/components";
import { breakpoints } from "common/styles";
import { useElementIsLoaded } from "common/utilities";
import { useTranslate } from "common/utilities/useTranslate";
import { StyledLandingText } from "domains/landing/components/StyledLandingText";
import { StyledLandingTitle } from "domains/landing/components/StyledLandingTitle";
import BriefingImage from "domains/landing/create/briefing-image.png";
import {
  SlidingContainer,
  StyledImage,
  StyledInfoContainer,
  StyledSectionContainer,
} from "domains/landing/create/shared";

const StyledBriefingInfoContainer = styled(StyledInfoContainer)`
  order: 1;
  @media ${breakpoints.medium} {
    order: 0;
  }
`;

export const BriefingSection = () => {
  const { isLoaded, elementRef } = useElementIsLoaded(0.5);
  const translate = useTranslate();

  return (
    <StyledSectionContainer ref={elementRef}>
      <StyledBriefingInfoContainer>
        <SlidingContainer $isLeft $isLoaded={isLoaded}>
          <StyledImage src={BriefingImage} alt={translate("app.topic.insight_briefing")} />
        </SlidingContainer>
      </StyledBriefingInfoContainer>
      <StyledInfoContainer>
        <div ref={elementRef}>
          <SlidingContainer $isLoaded={isLoaded}>
            <DigitalMemberTag trackPage="Landing" />
            <StyledLandingTitle>{translate("app.topic.actions.briefing")}</StyledLandingTitle>
            <StyledLandingText>{translate("app.briefing.promo_text1")}</StyledLandingText>
            <StyledLandingText>{translate("app.briefing.promo_text2")}</StyledLandingText>
          </SlidingContainer>
        </div>
      </StyledInfoContainer>
    </StyledSectionContainer>
  );
};
